@if (isNgbDropdownItem) {
  <button
    class="btn btn-progress"
    [disabled]="disabled"
    [ngClass]="btnClass"
    [type]="btnType"
    (click)="emitClick()"
    ngbDropdownItem
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
} @else {
  @if (hyperlink == undefined) {
    <button
      class="btn btn-progress"
      [disabled]="disabled"
      [ngClass]="btnClass"
      [type]="btnType"
      (click)="emitClick()"
    >
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </button>
  } @else {
    <a
      class="btn btn-progress"
      [ngClass]="btnClass"
      href="{{ hyperlink.href }}"
      role="button"
      target="{{ hyperlink.target }}"
    >
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </a>
  }
}
<ng-template #buttonContent>
  <div>
    <div class="content" #content>
      <ng-content></ng-content>
    </div>
    <div class="btn-progress-spinner hidden" #spinner>
      <div class="d-flex h-100">
        <span class="m-auto" #spinnerInner>
          @if (progressText) {
            <span>{{ progressText }}</span>
          } @else {
            <span><i class="far fa-circle-notch fa-spin"></i></span>
          }
        </span>
      </div>
    </div>
  </div>
  <div class="btn-progress-bar">
    <span class="btn-progress-bar-inner" #progressBar></span>
  </div>
</ng-template>
